import { CoreModule } from './core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';

import { registerLocaleData } from '@angular/common';
/* Module Imports */
import { HomeModule } from './home/home.module';
import { AccountModule } from './account/account.module';
import { ShellModule } from './shell/shell.module';
import { SharedModule } from './shared/shared.module';
import { DespachoModule } from './despacho/despacho.module';
import { RanchoModule } from './rancho/rancho.module';

// used to create fake backend
import { FakeBackendProvider } from './shared/mocks/fake-backend-interceptor';
import { HttpErrorHandler } from './http-error-handler.service';
import { MessageService } from './shell/message.service';
import { NgbModule, NgbDateNativeAdapter, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ManagementModule } from './management/management.module';
import { PreciosModule } from './precios/precios.module';
import { ModalConfirmComponent } from './shared/generic-modals/modal-confirm.component';
import localeEsAR from '@angular/common/locales/es-AR';
import { ModalOkComponent } from './shared/generic-modals/modal-ok.component';
import { AerovaleDetalleComponent } from './despacho/aerovale-detalle/aerovale-detalle.component';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { RouteReuseStrategy } from '@angular/router';
import { RouteReusableStrategy } from './core/route-reusable-strategy';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { FacturacionModule } from './facturacion/facturacion.module';
import { StockModule} from './stock/stock.module';
import { AbmModule} from './abm/abm.module';
import { ToastModule } from 'primeng/toast';
import { CanDeactivateGuard } from './core/can-deactivate-guard.service';
import {NgxPaginationModule, PaginatePipe} from 'ngx-pagination';
import { DatePipe } from '@angular/common';
import { ReportesModule } from './reportes/reportes.module';
import { CierreTurnoModule } from './cierreTurno/cierre-turno.module';
import { AjusteManualCombustibleComponent } from './stock/listados/ajuste-manual-combustible/ajuste-manual-combustible.component';
import { ToastrModule } from 'ngx-toastr';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { ControlCreditoModule } from './controlCredito/control-credito.module';

registerLocaleData(localeEsAR, 'es-Ar');

@NgModule({
  declarations: [
    AppComponent,
    AuthCallbackComponent,
    ModalConfirmComponent,
    ModalOkComponent,
  ],
  imports: [
    BrowserModule,
    NgxBarcode6Module,
    HttpClientModule,
    CoreModule,
    HomeModule,
    AccountModule,
    DespachoModule,
    ManagementModule,
    RanchoModule,
    AppRoutingModule,
    ShellModule,
    SharedModule,
    NoopAnimationsModule,
    BrowserAnimationsModule,
    FacturacionModule,
    ReportesModule,
    StockModule,
    AbmModule,
    ToastModule,
    NgxPaginationModule,
    NgbModule,
    PreciosModule,
    CierreTurnoModule,
    ControlCreditoModule,
    ToastrModule.forRoot(),
  ],
  providers: [
    PaginatePipe,
    DatePipe,
    CanDeactivateGuard,
    NgbDateNativeAdapter,
    HttpErrorHandler,
    NgbActiveModal,
    MessageService,
    { provide: LOCALE_ID, useValue: "es-AR" },
    // provider used to create fake backend
    FakeBackendProvider,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },   
    { provide: RouteReuseStrategy, useClass: RouteReusableStrategy },
  ],
  entryComponents: [
    ModalConfirmComponent,
    ModalOkComponent,
    AerovaleDetalleComponent,
    AjusteManualCombustibleComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
